// /react/login/main.jsx

import {
    createRoot,
} from "react-dom/client";

import {
    LoginApp,
} from "./LoginApp.jsx";

import {
    readThemeCache,
} from "/react/settings/theme-cache.js";

import {
    applySettingsTheme,
    bindSystemThemeSync,
} from "/react/settings/theme-runtime.js";


applySettingsTheme(
    readThemeCache()
);


bindSystemThemeSync(
    readThemeCache
);


const mount =
    document.getElementById(
        "react-login-root"
    );


if (!mount) {
    throw new Error(
        "missing_react_login_root"
    );
}


createRoot(
    mount
).render(
    <LoginApp />
);